<app-nav
    [titulo]="zona ? 'Editar zona: ' + zona.nombre : 'Nueva zona / Agrupación'"
    [descripcion]="zona ? 'Aquí podrá modificar los datos de la zona.' : 'Por favor complete todos los datos de la nueva zona o agrupación.'">
    <div class="edit-zona basic-avm-editor">
        <div class="form-stepper">
            <form [formGroup]="form" class="form-step">

                <h3 class="form-step-title">{{ zona ? 'Editar zona' : 'Nueva zona / Agrupación' }}</h3>
                <span class="form-step-description">
                    {{ zona ? 'Modificá los datos de la zona y guardá los cambios.' : 'Completá los datos de la nueva zona o agrupación.' }}
                </span>

                <mat-form-field class="garantor-form-field" appearance="outline">
                    <mat-label>Nombre</mat-label>
                    <input matInput formControlName="nombre" placeholder="Ej: Convenio Inmobiliaria X">
                    <mat-error *ngIf="form.controls['nombre'].hasError('required')">
                        El nombre es requerido
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="garantor-form-field" appearance="outline">
                    <mat-label>Aclaración</mat-label>
                    <textarea matInput formControlName="aclaracion" rows="3"
                        placeholder="Ej: Acuerdo especial con inmobiliaria X — vigente desde enero 2026"></textarea>
                </mat-form-field>

                <div class="form-radio-line">
                    <span class="radio-line-label">Estado</span>
                    <div class="radios">
                        <mat-radio-group formControlName="activo">
                            <mat-radio-button [value]="true">Activo</mat-radio-button>
                            <mat-radio-button [value]="false">Inactivo</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <div class="form-step-buttons">
                    <button mat-button type="button" class="garantor-button" (click)="cancel()">Cancelar</button>
                    <button mat-raised-button color="primary" type="button" class="garantor-button" (click)="save()">
                        {{ zona ? 'Guardar cambios' : 'Crear zona' }}
                    </button>
                </div>

            </form>
        </div>
    </div>
</app-nav>
